
<txp-edit-business-info
    (closeEvent)="onClose($event)"
    [isCreate]="isCreate">
</txp-edit-business-info>
